import { IgAppBanner } from "@src/components/Utils/IgAppBanner";

import { RecheckButton } from "./RecheckButton";
import { ExpectedFoundProp, OrgIdProp, VariantProp } from "./types";

export const HeadlessMissingAlert = ({
  orgId,
  additionalAlert,
  endContent,
}: OrgIdProp & VariantProp) => (
  <IgAppBanner
    dismissId="script-status-alert"
    title="Intelligems package not detected."
    message="Reinstall the package or verify domain settings."
    variant={additionalAlert ? "secondary" : "info"}
    buttons={[
      <RecheckButton
        key="recheck"
        orgId={orgId}
        additionalAlert={additionalAlert}
      />,
    ]}
    endContent={endContent}
  />
);

export const HeadlessDeprecatedAlert = ({
  orgId,
  expected,
  found,
  additionalAlert,
  endContent,
}: OrgIdProp & ExpectedFoundProp & VariantProp) => (
  <IgAppBanner
    dismissId="script-status-alert"
    title="Intelligems package deprecated."
    message={`Intelligems package (v${found}) deprecated. Update to (v${expected}) to reflect app changes`}
    variant={additionalAlert ? "secondary" : "info"}
    buttons={[
      <RecheckButton
        key="recheck"
        orgId={orgId}
        additionalAlert={additionalAlert}
      />,
    ]}
    endContent={endContent}
  />
);

export const HeadlessOutdatedAlert = ({
  orgId,
  expected,
  found,
  additionalAlert,
  endContent,
}: OrgIdProp & ExpectedFoundProp & VariantProp) => (
  <IgAppBanner
    dismissId="script-status-alert"
    title={`Your Intelligems package (v${found}) is out of date.`}
    message={`Update to (v${expected}) to ensure compatibility with our latest features.`}
    variant={additionalAlert ? "secondary" : "info"}
    buttons={[
      <RecheckButton
        key="recheck"
        orgId={orgId}
        additionalAlert={additionalAlert}
      />,
    ]}
    endContent={endContent}
  />
);
